<template>
  <div id="media-header" class="media-header">

    <!-- Video header -->
    <div
      v-if="isVideo"
      :id="`wistia_${this.video}`"
      class="wistia_embed">
      &nbsp;
    </div>

    <!-- Carousel header -->
    <template v-else>
      <transition
        appear
        name="fade"
        mode="out-in">

        <img
          :alt="images[displayedImageIndex].title"
          :src="images[displayedImageIndex].src"
          :key="displayedImageIndex"
          :width="images[displayedImageIndex].width"
          :height="images[displayedImageIndex].height"
          class="media-header__image"
        />

      </transition>
    </template>

    <button @click="showModal" class="media-header__modal-toggle">View Image</button>

  </div>
</template>

<script>
import { EventBus } from '../event-bus.js'

const REFRESH_RATE = 6000

export default {
  name: 'MediaHeader',

  props: {
    images: {
      type: Array,
      required: true
    },

    video: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      displayedImageIndex: 0
    }
  },

  computed: {
    isCarousel () {
      if (this.images.length > 1) {
        return true
      } else {
        return false
      }
    },

    isVideo () {
      if (this.video) {
        return true
      } else {
        return false
      }
    },

    modalContents () {
      return {
        image: this.images[0].src,
        title: this.images[0].title
      }
    }
  },

  mounted () {
    if (this.isVideo) {
      window.wistiaEmbed = Wistia.embed(this.video, {
        autoPlay: true,
        controlsVisibleOnLoad: false,
        doNotTrack: true,
        endVideoBehavior: 'loop',
        mute: true,
        muted: true,
        playbar: false,
        settingsControl: false,
        controlsAreVisible: false,
        videoFoam: {
          minHeight: 300
        }
      });
    }

    if (this.isCarousel) { this.startCarousel() }
  },

  destroyed () {
    if (this.timer) { clearInterval(this.timer) }
  },

  methods: {
    displayNextImage () {
      this.displayedImageIndex = (this.displayedImageIndex + 1) % this.images.length
    },
    startCarousel () {
      this.timer = setInterval(this.displayNextImage, REFRESH_RATE)
    },
    showModal () {
      EventBus.$emit('open-global-modal', this.modalContents)
    }
  }
}
</script>
